import { request } from '@/utils/request';
import APIURL from '@/api/apiUrl';
export function login(data) {
  return request.post(APIURL.user.login, data);
}
export function refreshtoken(data) {
  return request.post(APIURL.user.refreshtoken, data);
}
export function getInfo() {
  return request.get(APIURL.user.info);
}
export function logout(data) {
  //  data  新添加
  return request.post(APIURL.user.logout, data);
}